import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { add, remove } from 'shared/store/breadcrumbSlice';
import styles from './home.module.scss';
import {  Outlet } from 'react-router-dom';
import { getTimeSheetCount } from 'shared/store/timesheetCountSlice';
import { getLeaveCount } from 'shared/store/leaveCountSlice';
import { getApprovalCount } from 'shared/store/approvalCountSlice';
const Home = () => {
  const dispatch = useDispatch();
  useEffect(()=>{
    dispatch(remove());
    dispatch(add([]));
  },[]);


  useEffect(() => {
    dispatch(getTimeSheetCount());
    dispatch(getLeaveCount());
    dispatch(getApprovalCount());
  }, []);

 
  return (
    <div className={styles.wrapper}>
      <div className={styles.outletWrapper}>
        <Outlet/>
      </div>
    </div>
  );
};
export default Home;



